import * as React from "react";
import styled, { css } from "../../../styled/index";
import { CS } from "../../../styles/index";
import { RestaurantIcon, RestaurantIcons } from "../restaurant.icon/index";

const Wrapper = styled("div")<RestaurantDishTag["color"]["wrapper"]>`
  background: ${({background}) => background};
  color: ${({text}) => text};
  display: inline-block;
  border-radius: 30px;
  padding: 3px;
  font-size: 13px;
`;

const Content = styled("div")`
  min-height: 20px;
  ${CS.flex.line_center};
  flex-wrap: nowrap;
`;

const Icon = styled("div")<{type: "text" | "icon"; background: string; text: string}>`
  background: ${({background}) => background};
  color: ${({text}) => text};
  border-radius: 30px;
  padding: 3px ${({type}) => type === "text" ? 6 : 1}px;
  font-weight: 600;
  white-space: pre-wrap;
`;

const Text = styled("div")`
  margin: 0 5px;
  font-weight: 600;
  white-space: pre-wrap;
`;

export const DishTag = (props: RestaurantDishTag) => {

  const isIcon = props.type === "icon";

  return (
    <Wrapper {...props.color.wrapper}>
      <Content>
        {props.type !== "none" && (
          <Icon type={props.type} {...props.color.icon}>
            {isIcon && <RestaurantIcon icon={props.icon as RestaurantIcons}/>}
            {!isIcon && <span>{props.icon}</span>}
          </Icon>
        )}
        {props.text && <Text>{props.text}</Text>}
      </Content>
    </Wrapper>
  );

};
